import React, { Component } from 'react'
import { connect } from 'react-redux'
import { setPlaybook } from 'modules/filter_builder/actions'
import { Div } from '@driftt/tide-core'
import List from './List'

const EMAIL_PLAYBOOK_TYPES = [
  "OUTBOUND_SEQUENCE",
  "MARKETING_SEQUENCE",
  "MARKETING_ONE_TIME_SEQUENCE",
  "SEND_A_ONETIME_OUTBOUND_EMAIL",
  "SEND_A_ONETIME_EMAIL",
  "SEND_AN_AUTOMATED_EMAIL",
  "BLOG_NURTURE",
  "NEW_BLOG_CONTENT",
  "NEWSLETTER",
  "PRODUCT_ANNOUNCEMENT",
  "ABANDONED_BOOK_A_MEETING",
]

const CHAT_PLAYBOOK_TYPES = [
  "CONVO_CONTENT_CLP",
  "FORM_REPLACER_CLP",
  "PERSONAL_GREETING",
  "PAID_TRAFFIC_BOT",
  "ABM_HOMEPAGE_BOT",
  "SECOND_NET_BOT",
  "PRICING_PAGE_BOT",
  "RETARGETING_BOT",
  "CONVERSATION_STARTER_BOT",
  "BOOK_MORE_MEETINGS",
  "MORE_QUALIFIED_CONVERSATIONS",
  "MORE_SALES_CONVERSATIONS",
  "DRIVE_TRAFFIC_TARGETED_MESSAGE",
  "PROMOTION_FULL_SCREEN_TAKEOVER",
  "TALK_TO_YOUR_OUTBOUND_PROSPECTS",
  "BUILD_A_SUBSCRIBER_LIST",
  "EMPTY_LEADBOT",
  "EMPTY_SLIDER",
  "EMPTY_WELCOME_MESSAGE",
  "EMPTY_TAKEOVER",
  "NPS_BOT",
  "ABM",
  "LANDING_PAGE_LEADBOT",
  "VSB_DEFAULT_PLAYBOOK",
  "FORM_SUBMISSION_FAST_LANE",
  "ENGAGE_ALL_BOT",
  "SKIP_THE_FORM_BOT",
  "VISITOR_RETARGETING_BOT",
  "BLOG_BOT",
  "PAID_AD_CONVERTER_BOT",
  "TARGET_ACCOUNTS_BOT"
]

const mapStateToProps = state => ({
  playbooks: state.__CRM.filterBuilder.playbooks
})

const mapDispatchToProps = dispatch => {
  return {
    onSelectPlaybook: playbook => {
      dispatch(setPlaybook(playbook))
    }
  }
}

class PlaybookSelection extends Component {
  constructor(props) {
    super(props)

    this.state = {
      filteredPlaybooks: null
    }
  }
  componentDidMount() {
    this.formatData()
  }

  setPlaybook = (playbook, subEntityType) => {
    const { onPlaybookChoose } = this.props

    onPlaybookChoose(playbook)
  }

  formatData = () => {
    const { playbooks } = this.props

    const chatList = playbooks.filter(pb => CHAT_PLAYBOOK_TYPES.includes(pb.reportType))
    const emailList = playbooks.filter(pb => EMAIL_PLAYBOOK_TYPES.includes(pb.reportType))

    this.setState({
      filteredPlaybooks: [{
        title: 'Chat Playbooks',
        properties: chatList
      }, {
        title: 'Email Playbooks',
        properties: emailList
      }]
    })
  }

  render() {
    const { filteredPlaybooks } = this.state

    return (
      <Div className="contact-properties--container">
        <Div className="filter-builder--tabs">
          {!!filteredPlaybooks && 
            <List 
              properties={filteredPlaybooks}
              helpText={'Playbooks are messages created in Drift and delivered to site visitors via your Drift Widget or email'}
              hideType={true}
              onSelect={this.setPlaybook}
              subEntityType={'playbookEvents'}
              displayKey={'name'}
              filterKey={'id'}
            />
          }
        </Div>
      </Div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PlaybookSelection)
